<template>
  <div class="head">
    <div class="top">
      <div class="left">
        <span @click="show = true">
          {{ active?.customerName }}
          <van-icon name="play" />
        </span>
        <AdminControl />
      </div>
      <div v-show="active?.links?.length" class="iconfont" @click.stop="onPhone">&#xe70a;</div>
      <!-- <div v-if="active?.links?.length" class="iconfont">
        <a :href="`tel:${active?.links[0].phone}`"> <i class="iconfont">&#xe70a;</i></a>
      </div> -->
    </div>
    <div class="bot">
      <van-tag v-for="item in [active.serviceTypeStr, active.taxPayerTpyeStr, active.gradeName].filter((n) => n)" :key="item" class="custom-tag" round>{{ item }}</van-tag>
    </div>
  </div>

  <van-popup v-model:show="show" position="bottom">
    <van-picker :columns="customer" :columns-field-names="{ text: 'customerName', value: 'customerId' }" @cancel="show = false" @confirm="onConfirm" />
  </van-popup>
</template>
<script lang="ts" setup>
import { useMainStore } from "@/store";
import { wxPhone } from "@/utils/wx";
import { ref } from "vue";
import { storeToRefs } from "pinia";
import AdminControl from "@/components/adminControl/adminControl.vue";
const mainStore = useMainStore();
const { customer, customerInfo: active } = storeToRefs(mainStore);

const show = ref(false);
const onConfirm = (e: { selectedValues: string[] }) => {
  mainStore.setNowCustomer(e.selectedValues[0]);
  show.value = false;
};
const onPhone = () => {
  const obj = active.value.links[0];
  if (active) wxPhone(obj.phone || "");
};
</script>
<style lang="less" scoped>
.head {
  padding: 20px;
  border-bottom: 1px solid #ccc;
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .left {
      flex: 1;
      display: inline-block;
      align-items: center;
      font-weight: bold;
      font-size: 40px;
      overflow: hidden;
      cursor: pointer;
      .van-icon {
        margin: 0 20px;
        transform: rotate(90deg);
      }
    }
    .iconfont {
      font-size: @iconSize;
      color: #6fcc7f;
      cursor: pointer;
    }
  }
  .bot {
    display: flex;
    flex-wrap: wrap;
    max-height: 140px;
    overflow: auto;
    .custom-tag {
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
